import { connect } from 'react-redux'

import { getAuthError } from 'app/fieldapp/store/auth/selectors'
import { getAuthToken } from 'app/fieldapp/store/auth/selectors'
import { ApplicationState } from 'app/fieldapp/store/store'
import { fetchCurrentUser } from 'app/fieldapp/store/users/actions'
import { getActiveUser, getAuthUser } from 'app/fieldapp/store/users/selectors'

import { FieldAppIndex } from './FieldAppIndex'

const mapStateToProps = (state: ApplicationState) => ({
  getActiveUser: () => getActiveUser(state),
  getAuthError: () => getAuthError(state),
  getAuthToken: () => getAuthToken(state),
  getAuthUser: () => getAuthUser(state),
})

const mapDispatchToProps = dispatch => ({
  fetchCurrentUser: () => dispatch(fetchCurrentUser()),
})

export const FieldAppContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(FieldAppIndex)
